/* eslint-disable import/prefer-default-export */
export const PRIMARY_SHADOW = '#f0f4f7';
export const SECONDARY_SHADOW = '#dce6ed';
